import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {map, catchError} from 'rxjs/operators';
import {Observable} from 'rxjs';

import {endpoints} from '../endpoints';

@Injectable({
  providedIn: 'root'
})
export class RegistroService {
  parametros: any;

  constructor(private http: HttpClient) {
  }

  recuperarFormulario(codigoProceso: string): Observable<any> {
    const endpoint = endpoints.core.obtenerFormulario + '?codigo=' + codigoProceso;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.get(endpoint, {headers}).pipe(
      map(results => {
        return results;
      }),
      catchError(error => {
        throw new Error(error.error.message);
      })
    );
  }

  recuperarInstancia(idInstancia: string): Observable<any> {
    const endpoint = endpoints.core.obtenerInstancia + '?id=' + idInstancia;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.get(endpoint, {headers}).pipe(
      map(results => {
        return results;
      }),
      catchError(error => {
        throw new Error(error.error.message);
      })
    );
  }

  guardarDatosFormulario(id: string, codigoVersionProceso: string, dataJson: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    if (id !== null){
      this.parametros = {
        id,
        codigo_version: codigoVersionProceso,
        datos_solicitud: dataJson
      };
    } else {
      this.parametros = {
        codigo_version: codigoVersionProceso,
        datos_solicitud: dataJson
      };
    }

    return this.http.post(endpoints.core.guardarInstancia, JSON.stringify(this.parametros), {headers}).pipe(
      map(results => {
        return results;
      }),
      catchError(error => {
        throw new Error(error.error.message);
      })
    );
  }

  enviarSolicitud(id: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json'
      });

    this.parametros = {
      id
    };

    return this.http.post(endpoints.core.enviarSolicitud, JSON.stringify(this.parametros), {headers}).pipe(
      map(results => {
        return results;
      }),
      catchError(error => {
        throw new Error(error.error.message);
      })
    );
  }
}
